import { Component } from "@angular/core";
import { OnInit } from "@angular/core";
import { PatientDashboardComponent } from "../patient-dashboard/patient-dashboard.component";
import { MenuItem } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { Router } from "@angular/router";
import { UtilitiesService } from "src/app/utilities/utilities.service";
import { TraceClassDecorator } from "@sentry/angular";
import { User_Registration } from "../../../models/User";
import { ProviderStateService } from "src/app/services/provider-state.service";

@Component({
    selector: "app-topbar",
    templateUrl: "./app.topbar.component.html",
    styles: [".ui-tabmenuitem.ui-state-active { background-color: #ffffff;}"],
})
@TraceClassDecorator()
export class AppTopBarComponent implements OnInit {
    constructor(
        public app: PatientDashboardComponent,
        public DialogService: DialogService,
        private router: Router,
        private utilitiesService: UtilitiesService,
        private readonly providerstateService: ProviderStateService
    ) { }
    posting: boolean;
    items: MenuItem[];
    activeItem: MenuItem;
    provider_img: string;
    slug: string = "";
    data1
    is_primary_provider: boolean = false;
    async ngOnInit() {
        this.slug = this.providerstateService.getProviderSlug();
        this.provider_img = this.providerstateService.getLogoUrl();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        this.items = [
            {
                label: "Dashboard",
                icon: "fa fa-fw fa-bar-chart",
                command: (event) => {
                    this.RouterNavigation("/patient/dashboard");
                }
            },
            {
                label: "Doctors",
                icon: "pi pi-fw pi-user-plus",
                command: (event) => {
                    this.openLink('HOMPAGE_BASE_URL', "view-doctors", "eGlobalDoctors-View-All-Doctors");
                }
            },
            {
                label: "Specialties",
                icon: "pi pi-fw pi-plus-circle",
                command: (event) => {
                    this.openLink('HOMPAGE_BASE_URL', "view-specialties", "eGlobalDoctors-View-All-specialties");
                    ;
                }
            },

            {
                label: "FAQ",
                command: (event) => {
                    this.openLink('HOMPAGE_BASE_URL', "faq-patient", "eGlobalDoctors-View-FAQs");
                }
            },
            {
                label: "Contact Us",
                icon: "pi pi-fw pi-envelope",
                command: (event) => {
                    this.openLink('HOMPAGE_BASE_URL', "contactus", "eGlobalDoctors-View-Contact-Us");
                    ;
                }
            },
            {
                label: "Videos",
                icon: "pi pi-fw pi-desktop",
                command: (event) => {
                    this.RouterNavigation("/patient/expert-videos");
                }
            },
            {
                label: "FMC",
                icon: "fa fa-fw fa-user-md",
                command: (event) => {
                    this.RouterNavigation("/patient/Free-Medical-Counseling");
                }
            },
        ];
        // this.activeItem = this.items[0];
    }

    RouterNavigation(path: string) {
        this.router.navigate(["/" + this.slug + '/' + path]);
    }







    async openLink(base_url_name: string, link: string, target: string): Promise<void> {
        await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
    }
}
